export const notificationInitial = {
  notification: {
    message: "",
    description: "",
    type: "",
    dateTime: "",
  },
  versionBackend: "x",
};
